import React from "react";

export default function ResetPasswordRequestSuccess() {
    return (
        <>
            <h4 className="mb-3 fs-2">Požiadavka odoslaná</h4>
            <div className="fs-5">Do tvojej emailovej schránky bola odoslaná správa na obnovenie hesla.</div>
        </>
    );
}